import React from 'react';
import styles from './Input.module.css';

const Input = ({ label, id, type = 'text', ...props }) => (
    <div className={styles.formGroup}>
        {label && <label htmlFor={id} className={styles.label}>{label}</label>}
        <input id={id} type={type} className={styles.input} {...props} />
    </div>
);

export default Input;